// A minimal country code list for demonstration. You can expand this as needed.
export const countryCodes = [
  { code: '+1', name: 'United States' },
  { code: '+44', name: 'United Kingdom' },
  { code: '+91', name: 'India' },
  { code: '+880', name: 'Bangladesh' },
  { code: '+61', name: 'Australia' },
  { code: '+81', name: 'Japan' },
  { code: '+49', name: 'Germany' },
  { code: '+33', name: 'France' },
  { code: '+971', name: 'United Arab Emirates' },
  { code: '+86', name: 'China' },
  { code: '+39', name: 'Italy' },
  { code: '+7', name: 'Russia' },
  { code: '+34', name: 'Spain' },
  { code: '+55', name: 'Brazil' },
  { code: '+27', name: 'South Africa' },
  { code: '+82', name: 'South Korea' },
  { code: '+966', name: 'Saudi Arabia' },
  { code: '+92', name: 'Pakistan' },
  { code: '+98', name: 'Iran' },
  { code: '+90', name: 'Turkey' },
  { code: '+20', name: 'Egypt' },
  { code: '+94', name: 'Sri Lanka' },
  { code: '+62', name: 'Indonesia' },
  { code: '+84', name: 'Vietnam' },
  { code: '+234', name: 'Nigeria' },
  { code: '+60', name: 'Malaysia' },
  { code: '+351', name: 'Portugal' },
  { code: '+48', name: 'Poland' },
  { code: '+358', name: 'Finland' },
  { code: '+46', name: 'Sweden' },
  { code: '+47', name: 'Norway' },
  { code: '+31', name: 'Netherlands' },
  { code: '+41', name: 'Switzerland' },
  { code: '+32', name: 'Belgium' },
  { code: '+353', name: 'Ireland' },
  { code: '+63', name: 'Philippines' },
  { code: '+66', name: 'Thailand' },
  { code: '+64', name: 'New Zealand' },
  { code: '+998', name: 'Uzbekistan' },
  { code: '+373', name: 'Moldova' },
  { code: '+380', name: 'Ukraine' },
  { code: '+94', name: 'Sri Lanka' },
  { code: '+974', name: 'Qatar' },
  { code: '+968', name: 'Oman' },
  { code: '+965', name: 'Kuwait' },
  { code: '+961', name: 'Lebanon' },
  { code: '+962', name: 'Jordan' },
  { code: '+964', name: 'Iraq' },
  { code: '+972', name: 'Israel' },
  { code: '+357', name: 'Cyprus' },
  { code: '+30', name: 'Greece' },
  { code: '+351', name: 'Portugal' },
  { code: '+420', name: 'Czech Republic' },
  { code: '+36', name: 'Hungary' },
  { code: '+381', name: 'Serbia' },
  { code: '+370', name: 'Lithuania' },
  { code: '+371', name: 'Latvia' },
  { code: '+370', name: 'Lithuania' },
  { code: '+359', name: 'Bulgaria' },
  // ...add more as needed
];
